import { Component, OnInit } from "@angular/core";
import { ModalController, NavParams, IonicModule } from "@ionic/angular";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { HeaderComponent } from "../../../../components/header/header.component";

@Component({
    selector: "app-dont-understand",
    templateUrl: "./dont-understand.component.html",
    styleUrls: ["./dont-understand.component.scss"],
    standalone: true,
    imports: [
        HeaderComponent,
        IonicModule,
        TranslatePipe,
    ],
})
export class DontUnderstandComponent implements OnInit {
  pageTitle = "Leave syndicate";
  reason = "donot-understand";
  syndicateName: any;

  constructor(private modalCtrl: ModalController, private navParams: NavParams,
    public translate: TranslateService,
    private GTMsegment: GTMSegmentService) {
    this.GTMsegment.GTMPopupInitialization("leaveSyndicateReasonPopup-1");
  }


  ngOnInit() {
    this.syndicateName = this.navParams?.data.s_name

    this.translate.get(['dont-understand.pageTitle']).subscribe((res: string) => {
      this.pageTitle = (res["dont-understand.pageTitle"])
    }, err => { return (err) })
  }

  backToLeaveSyndicate() {
    this.modalCtrl.dismiss().catch(err => { return err });
  }

  leave() {
    this.modalCtrl.dismiss(this.reason).catch(err => { return err });
  }
}
